// 生成随机颜色
export function generateRandomColor() {
    const minLightness = 40, maxLightness = 60
    const minSaturation = 70, maxSaturation = 100

    // 生成HSL值
    const h = Math.floor(Math.random() * 360); // 色相 0-359
    const s = Math.floor(Math.random() * (maxSaturation - minSaturation + 1)) + minSaturation; // 饱和度
    const l = Math.floor(Math.random() * (maxLightness - minLightness + 1)) + minLightness; // 亮度

    const rgb = hslToRgb(h, s, l);
    return rgbToHex(rgb.r, rgb.g, rgb.b);
}

// HSL转RGB
function hslToRgb(h: number, s: number, l: number) {
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((h / 60) % 2 - 1));
    const m = l - c / 2;

    let r, g, b;

    if (h >= 0 && h < 60) {
        [r, g, b] = [c, x, 0];
    } else if (h >= 60 && h < 120) {
        [r, g, b] = [x, c, 0];
    } else if (h >= 120 && h < 180) {
        [r, g, b] = [0, c, x];
    } else if (h >= 180 && h < 240) {
        [r, g, b] = [0, x, c];
    } else if (h >= 240 && h < 300) {
        [r, g, b] = [x, 0, c];
    } else {
        [r, g, b] = [c, 0, x];
    }

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return { r, g, b };
}

// RGB转HEX
function rgbToHex(r: number, g: number, b: number) {
    return '#' + [r, g, b].map(x => {
        const hex = x.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    }).join('');
}

export const stringToColor = (str: string) => {
    // 简单的哈希函数，将字符串转换为哈希值
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // 从哈希值生成十六进制颜色代码
    let color = '#';
    for (let i = 0; i < 3; i++) {
        // 取哈希值的不同部分生成RGB分量
        const value = (hash >> (i * 8)) & 0xFF;
        // 转换为十六进制，确保两位数
        color += value.toString(16).padStart(2, '0');
    }

    return color;
}
export const stringToFixColor = (str: string) => {
    const colors = [
        '#4f46e5', '#0ea5e9', '#8b5cf6', '#10b981',
        '#f59e0b', '#ef4444', '#ec4899', '#6366f1',
        '#FF6B6B', // 珊瑚红
        '#FF8E3C', // 橙色
        '#FFD166', // 金黄色
        '#6A0572', // 深紫色
        '#A663CC', // 紫罗兰色
    ];
    // 计算字符串的简单哈希值
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // 取绝对值并对颜色数组长度取模
    const index = Math.abs(hash) % colors.length;

    return colors[index];
}